module.exports = __webpack_public_path__ + "img/deng3.193ebfc7.png";